const routes = [
	{
		path: '/',
		name: 'home',
		component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
	},
	{
		path: '/signup',
		name: 'signup',
		component: () => import(/* webpackChunkName: "signup" */ '../views/Signup.vue')
	},
	{
		path: '/test',
		name: 'test',
		component: () => import(/* webpackChunkName: "test" */ '../views/Test.vue')
	},
	{
		path: '/dashboard/server',
		name: 'server',
		component: () => import(/* webpackChunkName: "server" */ '../views/dashboard/system/server.vue')
	},
	{
		path: '/dashboard/privilege-setting',
		name: 'privilege-setting',
		component: () => import(/* webpackChunkName: "privilege-setting" */ '../views/dashboard/system/PrivilegeSetting.vue')
	},
	{
		path: '/about/:password?',
		name: 'about',
		component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
	},

	{
		path: '/courses',
		name: 'courses',
		component: () => import(/* webpackChunkName: "courses" */ '../views/content/courses/Courses.vue')
	},
	{
		path: '/dashboard/home',
		name: 'dashboard-home',
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/Dashboard.vue')
	},

	{
		path: '/dashboard/users',
		name: 'dashboard-users',
		component: () => import(/* webpackChunkName: "dashboard-users" */ '../views/dashboard/users/Users.vue')
	},
	{
		path: '/dashboard/watermark',
		name: 'dashboard-watermark',
		component: () => import(/* webpackChunkName: "dashboard-watermark" */ '../views/dashboard/Watermark.vue')
	},
	{
		path: '/dashboard/groups',
		name: 'dashboard-groups',
		component: () => import(/* webpackChunkName: "dashboard-groups" */ '../views/dashboard/users/Groups.vue')
	},
	{
		path: '/dashboard/my-profile',
		name: 'dashboard-my-profile',
		component: () => import(/* webpackChunkName: "dashboard-my-profile" */ '../views/dashboard/users/MyProfile.vue')
	},

	{
		path: '/dashboard/companies/manage',
		name: 'dashboard-companies-manage',
		component: () => import(/* webpackChunkName: "dashboard-companies" */ '../views/dashboard/Companies/Manage.vue')
	},
	{
		path: '/users/grouppage/:groupID',
		name: 'users-grouppage',
		component: () => import(/* webpackChunkName: "users-grouppage" */ '../views/dashboard/users/GroupPage.vue')
	},

	{
		path: '/dashboard/courses',
		name: 'dashboard-courses',
		component: () => import(/* webpackChunkName: "dashboard-courses" */ '../views/dashboard/content/courses/Home.vue')
	},
	{
		path: '/dashboard/courses/add',
		name: 'dashboard-courses-add',
		component: () => import(/* webpackChunkName: "dashboard-courses-add" */ '../views/dashboard/content/courses/Add.vue')
	},
	{
		path: '/dashboard/courses/edit/:recordID',
		name: 'dashboard-courses-edit',
		component: () => import(/* webpackChunkName: "dashboard-courses-edit" */ '../views/dashboard/content/courses/Add.vue')
	},
	{
		path: '/dashboard/courses/manage',
		name: 'dashboard-courses-manage',
		component: () => import(/* webpackChunkName: "dashboard-courses-manage" */ '../views/dashboard/content/courses/Manage.vue')
	},
	{
		path: '/dashboard/courses/terms',
		name: 'dashboard-courses-terms',
		component: () => import(/* webpackChunkName: "dashboard-courses-terms" */ '../views/dashboard/content/courses/Terms.vue')
	},
	{
		path: '/dashboard/courses/communication',
		name: 'dashboard-courses-communication',
		component: () => import(/* webpackChunkName: "dashboard-courses-communication" */ '../views/dashboard/content/courses/Communication.vue')
	},
	{
		path: '/dashboard/courses/specialties',
		name: 'dashboard-courses-specialties',
		component: () => import(/* webpackChunkName: "dashboard-courses-specialties" */ '../views/dashboard/content/courses/Specialties.vue')
	},
	{
		path: '/dashboard/courses/currencies',
		name: 'dashboard-courses-currencies',
		component: () => import(/* webpackChunkName: "dashboard-courses-currencies" */ '../views/dashboard/content/courses/Currencies.vue')
	},
	{
		path: '/dashboard/courses/scheduled',
		name: 'dashboard-courses-scheduled',
		component: () => import(/* webpackChunkName: "dashboard-courses-scheduled" */ '../views/dashboard/content/courses/Scheduled.vue')
	},
	{
		path: '/courses/:courseID',
		name: 'course',
		component: () => import(/* webpackChunkName: "course" */ '../views/content/courses/Course.vue')
	},

	{
		path: '/dashboard/companies',
		name: 'dashboard-companies',
		component: () => import(/* webpackChunkName: "dashboard-companies-manage" */ '../views/dashboard/Companies/Home.vue')
	},
	{
		path: '/dashboard/companies/add',
		name: 'companies-add',
		component: () => import(/* webpackChunkName: "dashboard-company-add" */ '../views/dashboard/Companies/Add.vue')
	},
	{
		path: '/dashboard/companies/edit/:recordID',
		name: 'companies-edit',
		component: () => import(/* webpackChunkName: "dashboard-company-add" */ '../views/dashboard/Companies/Add.vue')
	},

	{
		path: '/dashboard/ranks',
		name: 'dashboard-ranks',
		component: () => import(/* webpackChunkName: "dashboard-ranks" */ '../views/dashboard/ranks/Home.vue')
	},
	{
		path: '/dashboard/ranks/manage',
		name: 'dashboard-ranks-manage',
		component: () => import(/* webpackChunkName: "dashboard-ranks" */ '../views/dashboard/ranks/Manage.vue')
	},
	
	{
		path: '/dashboard/ranks/add',
		name: 'dashboard-ranks-add',
		component: () => import(/* webpackChunkName: "dashboard-ranks-add" */ '../views/dashboard/ranks/Add.vue')
	},
	{
		path: '/dashboard/ranks/edit/:recordID',
		name: 'dashboard-ranks-edit',
		component: () => import(/* webpackChunkName: "dashboard-ranks-add" */ '../views/dashboard/ranks/Add.vue')
	},
	
	{
		path: '/dashboard/replacement',
		name: 'dashboard-replacement',
		component: () => import(/* webpackChunkName: "dashboard-replacement" */ '../views/dashboard/content/replacement/Home.vue')
	},
	{
		path: '/dashboard/replacement/add',
		name: 'dashboard-replacement-add',
		component: () => import(/* webpackChunkName: "dashboard-replacement-add" */ '../views/dashboard/content/replacement/Add.vue')
	},
	{
		path: '/dashboard/replacement/edit/:recordID',
		name: 'dashboard-replacement-edit',
		component: () => import(/* webpackChunkName: "dashboard-replacement-edit" */ '../views/dashboard/content/replacement/Add.vue')
	},
	{
		path: '/dashboard/replacement/manage',
		name: 'dashboard-replacement-manage',
		component: () => import(/* webpackChunkName: "dashboard-replacement-manage" */ '../views/dashboard/content/replacement/Manage.vue')
	},
	{
		path: '/dashboard/replacement/terms',
		name: 'dashboard-replacement-terms',
		component: () => import(/* webpackChunkName: "dashboard-replacement-terms" */ '../views/dashboard/content/replacement/Terms.vue')
	},
	{
		path: '/dashboard/replacement/payment',
		name: 'dashboard-replacement-payment',
		component: () => import(/* webpackChunkName: "dashboard-replacement-payment" */ '../views/dashboard/content/replacement/Payment.vue')
	},
	{
		path: '/dashboard/replacement/offer/:offerID',
		name: 'dashboard-replacement-offer',
		component: () => import(/* webpackChunkName: "dashboard-replacement-offer" */ '../views/dashboard/content/replacement/Offer.vue')
	},
	{
		path: '/dashboard/replacement/specialties',
		name: 'dashboard-replacement-specialties',
		component: () => import(/* webpackChunkName: "dashboard-replacement-specialties" */ '../views/dashboard/content/replacement/Specialties.vue')
	},
	{
		path: '/dashboard/replacement/scheduled',
		name: 'dashboard-replacement-scheduled',
		component: () => import(/* webpackChunkName: "dashboard-replacement-scheduled" */ '../views/dashboard/content/replacement/Scheduled.vue')
	},
	{
		path: '/replacement',
		name: 'replacements',
		component: () => import(/* webpackChunkName: "replacements" */ '../views/content/replacements/Replacements.vue')
	},
	{
		path: '/replacement/:recordID',
		name: 'replacement',
		component: () => import(/* webpackChunkName: "replacement" */ '../views/content/replacements/Replacement.vue')
	},

	{
		path: '/dashboard/news',
		name: 'dashboard-news',
		component: () => import(/* webpackChunkName: "dashboard-news" */ '../views/dashboard/content/news/Home.vue')
	},
	{
		path: '/dashboard/news/add',
		name: 'dashboard-news-add',
		component: () => import(/* webpackChunkName: "dashboard-news-add" */ '../views/dashboard/content/news/Add.vue')
	},
	{
		path: '/dashboard/news/edit/:recordID',
		name: 'dashboard-news-edit',
		component: () => import(/* webpackChunkName: "dashboard-news-edit" */ '../views/dashboard/content/news/Add.vue')
	},
	{
		path: '/dashboard/news/manage',
		name: 'dashboard-news-manage',
		component: () => import(/* webpackChunkName: "dashboard-news-manage" */ '../views/dashboard/content/news/Manage.vue')
	},
	{
		path: '/dashboard/news/terms',
		name: 'dashboard-news-terms',
		component: () => import(/* webpackChunkName: "dashboard-news-terms" */ '../views/dashboard/content/news/Terms.vue')
	},
	{
		path: '/dashboard/news/scheduled',
		name: 'dashboard-news-scheduled',
		component: () => import(/* webpackChunkName: "dashboard-news-scheduled" */ '../views/dashboard/content/news/Scheduled.vue')
	},
	{
		path: '/news',
		name: 'news',
		component: () => import(/* webpackChunkName: "news" */ '../views/content/news/News.vue')
	},
	{
		path: '/news/:recordID',
		name: 'news-item',
		component: () => import(/* webpackChunkName: "news-item" */ '../views/content/news/NewsItem.vue')
	},

	{
		path: '/dashboard/ads',
		name: 'dashboard-ads',
		component: () => import(/* webpackChunkName: "dashboard-ads" */ '../views/dashboard/ads/Home.vue')
	},
	{
		path: '/dashboard/ads/add',
		name: 'dashboard-ads-add',
		component: () => import(/* webpackChunkName: "dashboard-ads-add" */ '../views/dashboard/ads/Add.vue')
	},
	{
		path: '/dashboard/ads/manage',
		name: 'dashboard-ads-manage',
		component: () => import(/* webpackChunkName: "dashboard-ads-manage" */ '../views/dashboard/ads/Manage.vue')
	},
	{
		path: '/dashboard/ads/edit/:recordID',
		name: 'dashboard-ads-edit',
		component: () => import(/* webpackChunkName: "dashboard-ads-edit" */ '../views/dashboard/ads/Add.vue')
	},
	{
		path: '/favorite',
		name: 'fav',
		component: () => import(/* webpackChunkName: "dashboard-favorite" */ '../views/Favorite.vue')
	},
	{
		path: '/search',
		name: 'search',
		component: () => import(/* webpackChunkName: "dashboard-search" */ '../views/Search.vue')
	},

	{
		path: '/dashboard/pinned',
		name: 'dashboard-pinned',
		component: () => import(/* webpackChunkName: "dashboard-pinned" */ '../views/dashboard/content/pinned/Home.vue')
	},
	{
		path: '/dashboard/pinned/add',
		name: 'dashboard-pinned-add',
		component: () => import(/* webpackChunkName: "dashboard-pinned-add" */ '../views/dashboard/content/pinned/Add.vue')
	},
	{
		path: '/dashboard/pinned/manage',
		name: 'dashboard-pinned-manage',
		component: () => import(/* webpackChunkName: "dashboard-pinned-manage" */ '../views/dashboard/content/pinned/Manage.vue')
	},

	{
		path: '/jobs/:jobID',
		name: 'job',
		component: () => import(/* webpackChunkName: "job" */ '../views/content/jobs/Job.vue')
	},
	{
		path: '/jobs',
		name: 'jobs',
		component: () => import(/* webpackChunkName: "jobs" */ '../views/content/jobs/Jobs.vue')
	},
	{
		path: '/dashboard/jobs',
		name: 'dashboard-jobs',
		component: () => import(/* webpackChunkName: "dashboard-jobs" */ '../views/dashboard/content/jobs/Home.vue')
	},
	{
		path: '/dashboard/jobs/edit/:recordID',
		name: 'dashboard-jobs-edit',
		component: () => import(/* webpackChunkName: "dashboard-jobs-edit" */ '../views/dashboard/content/jobs/Add.vue')
	},
	{
		path: '/dashboard/jobs/add',
		name: 'dashboard-jobs-add',
		component: () => import(/* webpackChunkName: "dashboard-jobs-add" */ '../views/dashboard/content/jobs/Add.vue')
	},
	{
		path: '/dashboard/jobs/manage',
		name: 'dashboard-jobs-manage',
		component: () => import(/* webpackChunkName: "dashboard-jobs-manage" */ '../views/dashboard/content/jobs/Manage.vue')
	},
	{
		path: '/dashboard/jobs/terms',
		name: 'dashboard-jobs-terms',
		component: () => import(/* webpackChunkName: "dashboard-jobs-terms" */ '../views/dashboard/content/jobs/Terms.vue')
	},
	{
		path: '/dashboard/jobs/scheduled',
		name: 'dashboard-jobs-scheduled',
		component: () => import(/* webpackChunkName: "dashboard-jobs-scheduled" */ '../views/dashboard/content/jobs/Scheduled.vue')
	},
	{
		path: '/library',
		name: 'library',
		component: () => import(/* webpackChunkName: "library" */ '../views/content/medicalLibrary/Library.vue')
	},
	
	{
		path: '/dashboard/library',
		name: 'dashboard-library',
		component: () => import(/* webpackChunkName: "dashboard-library" */ '../views/dashboard/content/library/Home.vue')
	},
	{
		path: '/dashboard/library/add',
		name: 'dashboard-library-add',
		component: () => import(/* webpackChunkName: "dashboard-library-add" */ '../views/dashboard/content/library/Add.vue')
	},
	{
		path: '/dashboard/library/edit/:recordID',
		name: 'dashboard-library-edit',
		component: () => import(/* webpackChunkName: "dashboard-library-edit" */ '../views/dashboard/content/library/Add.vue')
	},
	{
		path: '/dashboard/library/manage',
		name: 'dashboard-library-manage',
		component: () => import(/* webpackChunkName: "dashboard-library-manage" */ '../views/dashboard/content/library/Manage.vue')
	},
	{
		path: '/dashboard/library/terms',
		name: 'dashboard-library-terms',
		component: () => import(/* webpackChunkName: "dashboard-library-terms" */ '../views/dashboard/content/library/Terms.vue')
	},
	{
		path: '/dashboard/library/types',
		name: 'dashboard-library-types',
		component: () => import(/* webpackChunkName: "dashboard-library-types" */ '../views/dashboard/content/library/Types.vue')
	},
	{
		path: '/dashboard/library/scheduled',
		name: 'dashboard-library-scheduled',
		component: () => import(/* webpackChunkName: "dashboard-library-scheduled" */ '../views/dashboard/content/library/Scheduled.vue')
	},
	{
		path: '/library/:recordID',
		name: 'library-item',
		component: () => import(/* webpackChunkName: "library-item" */ '../views/content/medicalLibrary/LibraryItem.vue')
	},
	// {
	// 	path: '/library',
	// 	name: 'library',
	// 	component: () => import(/* webpackChunkName: "library" */ '../views/content/library/Library.vue')
	// },

	{
		path: '/dashboard/events',
		name: 'dashboard-events',
		component: () => import(/* webpackChunkName: "dashboard-events" */ '../views/dashboard/content/events/Home.vue')
	},
	{
		path: '/dashboard/events/add',
		name: 'dashboard-events-add',
		component: () => import(/* webpackChunkName: "dashboard-events-add" */ '../views/dashboard/content/events/Add.vue')
	},
	{
		path: '/dashboard/events/edit/:recordID',
		name: 'dashboard-events-edit',
		component: () => import(/* webpackChunkName: "dashboard-events-edit" */ '../views/dashboard/content/events/Add.vue')
	},
	{
		path: '/dashboard/events/manage',
		name: 'dashboard-events-manage',
		component: () => import(/* webpackChunkName: "dashboard-events-manage" */ '../views/dashboard/content/events/Manage.vue')
	},
	{
		path: '/dashboard/events/terms',
		name: 'dashboard-events-terms',
		component: () => import(/* webpackChunkName: "dashboard-events-terms" */ '../views/dashboard/content/events/Terms.vue')
	},
	{
		path: '/dashboard/events/scheduled',
		name: 'dashboard-events-scheduled',
		component: () => import(/* webpackChunkName: "dashboard-events-scheduled" */ '../views/dashboard/content/events/Scheduled.vue')
	},
	{
		path: '/dashboard/weeklyNewsEditor',
		name: 'dashboard-weekly-news-editor',
		component: () => import(/* webpackChunkName: "dashboard-weekly-news-editor" */ '../views/dashboard/WeeklyNewsEditor.vue')
	},
	// {
	// 	path: '/dashboard/events/communication',
	// 	name: 'dashboard-events-communication',
	// 	component: () => import(/* webpackChunkName: "dashboard-events-communication" */ '../views/dashboard/content/events/Communication.vue')
	// },
	// {
	// 	path: '/dashboard/events/specialties',
	// 	name: 'dashboard-events-specialties',
	// 	component: () => import(/* webpackChunkName: "dashboard-events-specialties" */ '../views/dashboard/content/events/Specialties.vue')
	// },
	{
		path: '/events',
		name: 'events',
		component: () => import(/* webpackChunkName: "events" */ '../views/content/events/Events.vue')
	},
	{
		path: '/events/:recordID',
		name: 'event',
		component: () => import(/* webpackChunkName: "event" */ '../views/content/events/Event.vue')
	},
	{
		path: '/dashboard/logs',
		name: 'dashboard-logs',
		component: () => import(/* webpackChunkName: "dashboard-logs" */ '../views/dashboard/system/Logs.vue')
	},
	{
		path: '/dashboard/info',
		name: 'dashboard-info',
		component: () => import(/* webpackChunkName: "dashboard-info" */ '../views/dashboard/system/Info.vue')
	},
	{
		path: '/dashboard/locations',
		name: 'dashboard-locations',
		component: () => import(/* webpackChunkName: "dashboard-locations" */ '../views/dashboard/system/Locations.vue')
	},
	{
		path: '/dashboard/profile/:id',
		name: 'dashboard-profile',
		component: () => import(/* webpackChunkName: "dashboard-profile" */ '../views/dashboard/system/Profile.vue')
	},
	{
		path: '/dashboard/specialties',
		name: 'dashboard-specialties',
		component: () => import(/* webpackChunkName: "dashboard-specialties" */ '../views/dashboard/system/Specialties.vue')
	},

	{
		path: '/dashboard/about',
		name: 'dashboard-about',
		component: () => import(/* webpackChunkName: "dashboard-about" */ '../views/dashboard/system/About.vue')
	},
	{
		path: '/dashboard/privacy-policy',
		name: 'dashboard-privacy-policy',
		component: () => import(/* webpackChunkName: "dashboard-privacy-policy" */ '../views/dashboard/system/PrivacyPolicy.vue')
	},
	{
		path: '/dashboard/terms-of-usage',
		name: 'dashboard-terms-of-usage',
		component: () => import(/* webpackChunkName: "dashboard-terms-of-usage" */ '../views/dashboard/system/TermsOfUsage.vue')
	},
	{
		path: '/dashboard/sponsors',
		name: 'dashboard-sponsors',
		component: () => import(/* webpackChunkName: "dashboard-sponsors" */ '../views/dashboard/system/Sponsors.vue')
	},
	{
		path: '/dashboard/communication',
		name: 'dashboard-communication',
		component: () => import(/* webpackChunkName: "dashboard-communication" */ '../views/dashboard/system/Communication.vue')
	},
	{
		path: '/dashboard/communication-types',
		name: 'dashboard-communication-types',
		component: () => import(/* webpackChunkName: "dashboard-communication-types" */ '../views/dashboard/system/CommunicationTypes.vue')
	},
	{
		path: '/dashboard/notifications',
		name: 'dashboard-notifications',
		component: () => import(/* webpackChunkName: "dashboard-notifications" */ '../views/dashboard/system/Notifications.vue')
	},

	{
		path: '/public/privacy-policy',
		name: 'public-privacy-policy',
		component: () => import(/* webpackChunkName: "public-privacy-policy" */ '../views/public/PrivacyPolicy.vue')
	},
	{
		path: '/public/about',
		name: 'public-about',
		component: () => import(/* webpackChunkName: "public-about" */ '../views/public/About.vue')
	},
	{
		path: '/public/payment-methods',
		name: 'public-payment-methods',
		component: () => import(/* webpackChunkName: "public-payment-methods" */ '../views/public/PaymentMethods.vue')
	},

	{
		path: '/NonAuthorized',
		name: 'non-authorized',
		component: () => import(/* webpackChunkName: "non-authorized" */ '../views/NonAuthorized.vue')
	},
];

export default routes;